import { render, staticRenderFns } from "./takeaway_card.vue?vue&type=template&id=2d2f0a7b&scoped=true&"
import script from "./takeaway_card.vue?vue&type=script&lang=js&"
export * from "./takeaway_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2f0a7b",
  null
  
)

export default component.exports